<template>
  <div class="LinkPush">
    <a :href="data.link" target="_blank">
      <p>{{ data.title }}</p>
      <i class="far fa-arrow-right"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: "LinkPush",
    props: [ 'data' ]
  }
</script>

<style lang="stylus" scoped>
.LinkPush

  cursor pointer
  position relative
  background: #FFFFFF;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 5px;
  margin-bottom 10px
  width 100%
  box-sizing border-box
  min-height 73px
  padding 20px 20px
  display flex
  flex-direction column
  align-items center
  transition box-shadow 1s $ease

  @media $small

    min-height 45px
    padding 10px 20px

  &:hover

    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.25);

    i 

      transform translateX(-8px) scale(1.3)

  a

    display flex
    margin auto
    width 100%
    text-decoration none
    flex-direction row
    align-items center
    justify-content space-between
    font-size: 12px;
    line-height: 14px;

  p

    width 85%
    color: $blue
    font-family: $f-title
    font-weight 500
    font-size: 14px;
    letter-spacing: -0.3px;
    line-height: 17px;

    @media $small

      font-size: 12px;
      line-height: 14px;

  i

    color $red
    display block
    transition transform 0.6s $back

.ie

  .LinkPush

    height 73px
</style>